const avatarNames = new Set([
  'running', 'boxing', 'swimming', 'yoga', 'basketball', 'weightlifting', 'jump-rope', 'cycling',
]);

// Support profiles saved before the optimized avatar URLs were introduced.
export function localAvatar(src: string | undefined): string | undefined {
  const match = src?.match(/^(?:https:\/\/owlbuy\.cn)?\/media\/avatars\/([\w-]+)(?:\.(?:jpg|png|webp))?$/);
  return match && avatarNames.has(match[1]) ? `/media/optimized/avatars/${match[1]}.webp` : src;
}
